import { Injectable } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { BalanceService } from '../../account/balance/balance.service';
import { AuctionService } from '../../loyalty/auction/auction.service';
import { AuctionUpdateMessage } from '../../loyalty/auction/models/auction-update-message';
import { config } from '../../shared/config';
import { ISignalRService } from './signalr-service.interface';


 @Injectable({ providedIn: 'root' })
 export class SignalRAuctionService implements ISignalRService {
   constructor(private auctionService: AuctionService, private balanceService:BalanceService) {}

   /** @inheritdoc */
   registerOnServerEvents(connection: HubConnection): void {
     connection.on('AuctionUpdateAfterBid', (auctionUpdateMessage: AuctionUpdateMessage) => {
       this.auctionService.updateAuctionAfterBid(auctionUpdateMessage);
     });

     connection.on('OutBidUserUpdate', () => {
      this.balanceService.fetchBalance(config.purseConfig.virtualLoyalty).toPromise();
    });
   }
}
